/**
 * Shared, byte-keyed cache of per-page text runs (pdf.js extraction). Both the
 * search panel and text-markup read from this so a document is only parsed once.
 */
import { extractDocumentText } from './pdf-text.js';
import type { PageText } from './search.js';

const cache = new WeakMap<Uint8Array, PageText[]>();

/** Extract per-page text runs for the given bytes, cached by buffer identity. */
export async function getPageTexts(bytes: Uint8Array): Promise<PageText[]> {
  const hit = cache.get(bytes);
  if (hit) return hit;
  const pages = await extractDocumentText(bytes);
  cache.set(bytes, pages);
  return pages;
}
